function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg104AntiguaAndBarbuda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "369.883,208.509 142.117,208.509 188.651,186.618 163.871,141.552 214.4,151.217   220.806,100.172 256,137.716 291.197,100.172 297.599,151.217 348.13,141.552 323.351,186.622 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M88.751,204.797c-2.239,16.543-3.417,33.665-3.417,51.201s1.179,34.657,3.417,51.201L256,322.781  l167.249-15.583c2.239-16.543,3.417-33.665,3.417-51.201s-1.179-34.657-3.417-51.201"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M423.249,307.198H88.751C104.564,424.049,173.433,512,256,512S407.436,424.049,423.249,307.198z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "255.997,511.994 0,0 0,511.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "512,511.994 512,0 256.003,511.994  "
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg104AntiguaAndBarbuda);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzY5Ljg4MywyMDguNTA5IDE0Mi4xMTcsMjA4LjUwOSAxODguNjUxLDE4Ni42MTggMTYzLjg3MSwxNDEuNTUyIDIxNC40LDE1MS4yMTcgICAyMjAuODA2LDEwMC4xNzIgMjU2LDEzNy43MTYgMjkxLjE5NywxMDAuMTcyIDI5Ny41OTksMTUxLjIxNyAzNDguMTMsMTQxLjU1MiAzMjMuMzUxLDE4Ni42MjIgIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBkPSJNODguNzUxLDIwNC43OTdjLTIuMjM5LDE2LjU0My0zLjQxNywzMy42NjUtMy40MTcsNTEuMjAxczEuMTc5LDM0LjY1NywzLjQxNyw1MS4yMDFMMjU2LDMyMi43ODEgIGwxNjcuMjQ5LTE1LjU4M2MyLjIzOS0xNi41NDMsMy40MTctMzMuNjY1LDMuNDE3LTUxLjIwMXMtMS4xNzktMzQuNjU3LTMuNDE3LTUxLjIwMSIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRjBGMEYwOyIgZD0iTTQyMy4yNDksMzA3LjE5OEg4OC43NTFDMTA0LjU2NCw0MjQuMDQ5LDE3My40MzMsNTEyLDI1Niw1MTJTNDA3LjQzNiw0MjQuMDQ5LDQyMy4yNDksMzA3LjE5OHoiLz4KPGc+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSIyNTUuOTk3LDUxMS45OTQgMCwwIDAsNTExLjk5NCAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojQTIwMDFEOyIgcG9pbnRzPSI1MTIsNTExLjk5NCA1MTIsMCAyNTYuMDAzLDUxMS45OTQgICIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };